<template>
  <div class="flex flex-col gap-1.5">
    <div class="flex items-center gap-1">
      <label :for="id" class="text-base leading-[22px] font-medium text-label">{{ label }}</label>
      <InfoButton v-if="info" :subject="label" :text="info" />
    </div>
    <slot />
    <p v-if="hint" :id="`${id}-hint`" class="text-[14px] leading-[22px] font-medium text-body">{{ hint }}</p>
    <p v-if="error" :id="`${id}-error`" class="text-[14px] font-medium text-red-600">{{ error }}</p>
  </div>
</template>

<script setup lang="ts">
import InfoButton from '@/components/form/InfoButton.vue'

defineProps<{
  /** The id of the control in the slot, so the label and the error message point at it. */
  id: string
  label: string
  info?: string
  /** A note about the chosen value, standing under the control so it cannot be clipped by it. */
  hint?: string
  error?: string
}>()
</script>
